import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { MatSnackBar } from '@angular/material';

import { FireDataService } from '../fire-data.service';
import { DialogsService } from '../dialogs.service';


@Component({
  selector: 'app-teacher-lack',
  templateUrl: './teacher-lack.component.html',
  styleUrls: ['./teacher-lack.component.css']
})
export class TeacherLackComponent implements OnInit {

    //snap: Object;
  arrDays: Array<any>;
  arrDate: Array<any>;
  fillDays: Array<any>;  //used to fill header grid with days needed to 7
  snap: Array<any>; // two dimensions, contains all schedule cols ad rows
  snapSelected: Array<any>; // used to select two item from snal to createS ubstitution record
  fillRow: Array<any>; // one dimension, contain fill data to color every cols of snap

  private day: string; 
  private week: number;
  private requestDay: number;

  gridHeader = [{text: 'Teacher', cols: 3, rows: 1, color: 'lightgray'},
                {text: '08:10', cols: 1, rows: 1, color: 'lightgray'},{text: '09:05', cols: 1, rows: 1, color: 'lightgray'},
                {text: '10:00', cols: 1, rows: 1, color: 'lightgray'},{text: '11:10', cols: 1, rows: 1, color: 'lightgray'},
                {text: '12:05', cols: 1, rows: 1, color: 'lightgray'},{text: '12:55', cols: 1, rows: 1, color: 'lightgray'},
                {text: '13:45', cols: 1, rows: 1, color: '#afb8cc'},{text: '14:35', cols: 1, rows: 1, color: '#afb8cc'},
                {text: '15:25', cols: 1, rows: 1, color: '#afb8cc'},{text: '16:15', cols: 1, rows: 1, color: '#afb8cc'}];

  gridLegenda = [{class:'material-icons mat-18 bluegrey800', icon: 'directions_run', text: '', description:'classe in uscita didattica'},
                 {class:'material-icons mat-18 bluegrey800', icon: 'people', text: '', description:'ora ricevimento'},
                 {class:'', icon: '', text: '- R -', description:'recupero ora permesso'},
                 {class:'', icon: '', text: 'D', description:'disponibile per sostituzioni'},
                 {class:'', icon: '', text: 'Dx', description:'disponibile per completamento orario, la seconda lettera è riferita alla sede'}]

  constructor(private fds: FireDataService, private router: Router, private route: ActivatedRoute, private location: Location, 
              private dialogsService: DialogsService, public snackBar: MatSnackBar) {
    //this.isLogged();
    this.arrDays = [], this.arrDate = [], this.fillDays = [];
    this.snap = [], this.snapSelected = [];
    this.snap.push(this.gridHeader)

    this.fillRow = [];
  
    this.fillRow.length = 11;
    this.fillRow = Array.from(this.fillRow, function(val, idx){return {text: ' ', cols: 1, rows: 1, color: '#E3F2FD', regArray: [], note: ''}} );
    this.fillRow[0].cols = 3;

   }

  ngOnInit() {
        this.route.params.subscribe(params => {
        this.day = params["day"] || '';
        this.week = params["wk"] | 0;
        this.requestDay = Number(params["epoch"] || 0);
        const msDay = 24*60*60*1000
        var dNow = Date.now()
        var dw = new Date().getDay()
        var dayLun = dNow-((dw-1)*msDay)
        var dwSelected = -1;
        var pp = this
        if (this.arrDays.length == 0) {
            var tt = this.arrDays ;
            var ff = this.fillDays;
            var dd = this.arrDate;
            this.fds.readDays()
                .then(function(res) {
                  Object.keys(res).map(key => tt.push(res[key]));
                  for (let i=0; i < tt.length; i++) {
                    var dLoc = new Date(dayLun+i*msDay + pp.week*7*msDay )
                    dd.push({'short': dLoc.toLocaleDateString('it-IT', {day:'2-digit', month:'short'}), 
                             'epoch': new Date(dLoc.getFullYear(),dLoc.getMonth(), dLoc.getDate()).valueOf()})
                  }
                  for (let i=0; i < 6-tt.length; i++) {ff.push(' ')}
                  });
        }
        this.buildTeacherArray();
        this.snapSelected = [];
    });
  }

  private buildTeacherArray() {
    for (var i = this.snap.length; i > 1; i--) {
      this.snap.pop();
    }
    if (this.requestDay) {
       this.fds.getTeacherLack(this.requestDay, this.snap, this.fillRow, '#90CAF9', '#90CAF9', '#BBDEFB')
          .then(res => {
                //console.log("Dataset...:", this.snap)
          });
      }
  }

  public itemSelected (type, teacher, hour, group, endDate, r, i) {
    if (this.snapSelected.length == 1) {
      if (this.snapSelected[0].row == r && this.snapSelected[0].col == i) {
        this.snap[r][i].color = this.snapSelected[0].backgroundColor;
        this.snapSelected = [];
        return
      } else {
        if (this.snapSelected[0].col !== i && type !== 'SHC') {return}
        if (this.snapSelected[0].type == 'A' && type == 'A'){return}
        if (this.snapSelected[0].type !== 'A' && type !== 'A'){return}
        this.snapSelected.push({"row": r, "col":i, "type": type, "teacher": teacher, "hour": hour, "group": group ,
                                "backgroundColor": this.snap[r][i].color, "requestDay": this.requestDay, "endDate": endDate});
        if (type !== 'SHC') {this.snap[r][i].color = '#FF8A80'}
        console.log("Snap selected ...", this.snapSelected)
        this.dialogsService
        .confirm('Conferma scelte', 'Premi Ok per creare la sostituzione o Cancel per annullare le selezioni' )
        .subscribe(res => {
          if (res) {
            this.fds.createSubstitutionCase(this.snapSelected)
            .then(res => {
              this.snackBar
              .open('Sostituzione creata con successo', '(chiudi)', {
                duration: 5000
              });
              this.buildTeacherArray();
            })
            .catch(err => {
              console.log("reg error...:", err) // usare snackbar
            });
          }
          this.snap[this.snapSelected[0].row][this.snapSelected[0].col].color = this.snapSelected[0].backgroundColor;
          this.snap[this.snapSelected[1].row][this.snapSelected[1].col].color = this.snapSelected[1].backgroundColor;
          this.snapSelected = [];
        });
      }
    }
    if (this.snapSelected.length < 2) {this.snapSelected.push({"row": r, "col":i, "type": type, "teacher": teacher, "hour": hour, 
                    "group": group ,"backgroundColor": this.snap[r][i].color, "requestDay": this.requestDay, "endDate": endDate})}
      this.snap[r][i].color = '#FF8A80';
  }

  public deleteSubstitution(regArray) {
    var self = this;
    this.dialogsService
    .confirm('Sei sicuro/a di voler cancellare la sostituzione?', 'Premi OK per CANCELLARE la sostituzione o Cancel per non farlo' )
    .subscribe(res => {
      if (res) {
        self.fds.deleteSubstitutionCase(regArray)
        .then(res => {
          this.snackBar
          .open('Sostituzione cancellata con successo', '(chiudi)', {
            duration: 5000
          });
          self.buildTeacherArray();
        })
        .catch(err =>{
          console.log("Error on deleting Substitution", err)
        })
      }
    });
  }

  public btWeek (op) {
    this.week = this.week+op
    this.arrDate = [];
        const msDay = 24*60*60*1000
        var dNow = Date.now()
        var dw = new Date().getDay()
        var dayLun = dNow-((dw-1)*msDay) + this.week*7*msDay;
    for (let i=0; i < this.arrDays.length; i++) {
      var dLoc = new Date(dayLun+i*msDay)
      this.arrDate.push({'short': dLoc.toLocaleDateString('it-IT', {day:'2-digit', month:'short'}), 
                         'epoch': new Date(dLoc.getFullYear(),dLoc.getMonth(), dLoc.getDate()).valueOf()})
      if (i+1 == Number(this.day.substr(0,1))) {this.requestDay = this.arrDate[this.arrDate.length-1].epoch}
    }
    this.router.navigate(["/teacher-lack", this.requestDay, this.day, this.week]);
  }

  public goBack() {
    this.location.back();

  }

  private isLogged() {
    this.fds.user.subscribe(res => {
      if (res) {
        return
      }
      if (!res) {
        this.router.navigate(["/login"]);
      }
    });
  } 

}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/teacher-lack/teacher-lack.component.ts